'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  size: 128,
  options: {
    scale: 5,
    color: {
      dark: '#000000',
      light: '#ffffff'
    }
  }
};